import { memo } from 'react'
import StrikeTooltipOiBar from '../../../../components/StrikeTooltip/StrikeTooltipOiBar'
import { OptionSecurity } from '../../../typings/options.typings'

type OptionChainOiBarProps = {
    text: OptionSecurity & {
        oiRank?: number
    }
    side: string
}

/** OI bar below cell text; puts grow from left, calls from right (toward strike). */
const OptionChainOiBar = ({ text, side }: OptionChainOiBarProps) => {
    const openInterest = text?.openInterest ?? 0
    if (openInterest === 0) {
        return null
    }

    return (
        <div className="option-chain-oi-bar-row">
            <StrikeTooltipOiBar
                className="option-chain-oi-track"
                oiRank={text?.oiRank ?? 0}
                openInterest={openInterest}
                oiChangeRaw={text?.oiChanges?.oiChange?.change}
                align={side === 'left' ? 'end' : 'start'}
            />
        </div>
    )
}

export default memo(OptionChainOiBar)
